import { render, staticRenderFns } from "./replace_admin.vue?vue&type=template&id=39058601&scoped=true&"
import script from "./replace_admin.vue?vue&type=script&lang=js&"
export * from "./replace_admin.vue?vue&type=script&lang=js&"
import style0 from "./replace_admin.vue?vue&type=style&index=0&id=39058601&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39058601",
  null
  
)

export default component.exports